import { css } from "@emotion/react";
import { colors } from "./colors";
import { font } from "./font";

export const theme = {
  colors,
  font,
  spacing: (factor: number) => `${factor * 4}px`,
  borderRadius: (factor: number) => `${factor * 4}px`,
};
export { FontFamily } from "./font";

export const globalStyles = css`
  * {
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-family:
      ${theme.font.body.fontFamily} -apple-system,
      Arial,
      sans-serif;
    background-color: ${theme.colors.background.primary};
    color: ${theme.colors.text.primary};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: auto;
    width: 100%;
  }

  html {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  ::-webkit-scrollbar {
    display: none;
    width: 8px;
    background-color: ${theme.colors.background.secondary};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.accent.primary};
    border-radius: 8px;
  }
`;
